export class EmployeeId {
    id: number

    constructor(id: number) {
        this.id = id;
    }

}

export class departmentIdReq{
    departmentId?:number
    vendorId?:number
    
    role?:string
    plant?:string
    extNo?:string
    constructor(
    departmentId?:number,
    vendorId?:number,
    role?:string,
    plant?:string,
    extNo?:string
    ){
        this.departmentId=departmentId
        this.vendorId=vendorId
        this.role=role
        this.plant=plant
        this.extNo=extNo
    }
}